/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceDto } from "./DeviceDto";
import {
    DeviceDtoFromJSON,
    DeviceDtoFromJSONTyped,
    DeviceDtoToJSON,
} from "./DeviceDto";

/**
 *
 * @export
 * @interface DeviceListReponse
 */
export interface DeviceListReponse {
    /**
     *
     * @type {Array<string>}
     * @memberof DeviceListReponse
     */
    errors?: Array<string>;
    /**
     *
     * @type {Array<DeviceDto>}
     * @memberof DeviceListReponse
     */
    devices?: Array<DeviceDto>;
    /**
     *
     * @type {number}
     * @memberof DeviceListReponse
     */
    nextCursor?: number;
}

/**
 * Check if a given object implements the DeviceListReponse interface.
 */
export function instanceOfDeviceListReponse(
    value: object,
): value is DeviceListReponse {
    return true;
}

export function DeviceListReponseFromJSON(json: any): DeviceListReponse {
    return DeviceListReponseFromJSONTyped(json, false);
}

export function DeviceListReponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceListReponse {
    if (json == null) {
        return json;
    }
    return {
        errors: json["errors"] == null ? undefined : json["errors"],
        devices:
            json["devices"] == null
                ? undefined
                : (json["devices"] as Array<any>).map(DeviceDtoFromJSON),
        nextCursor: json["nextCursor"] == null ? undefined : json["nextCursor"],
    };
}

export function DeviceListReponseToJSON(value?: DeviceListReponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        errors: value["errors"],
        devices:
            value["devices"] == null
                ? undefined
                : (value["devices"] as Array<any>).map(DeviceDtoToJSON),
        nextCursor: value["nextCursor"],
    };
}
